import axios from 'axios';
import { baseUrl } from './config';

// eslint-disable-next-line import/prefer-default-export
export const quickValidate = (data) =>
  axios.post(`${baseUrl}/validation`, data);
